// ============================================================
// SEGUIMIENTO MACROS — página wrapper
// ============================================================
import React from 'react';
import SeguimientoMacros from '../components/SeguimientoMacros';

const SeguimientoMacrosPage: React.FC = () => {
    return <SeguimientoMacros />;
};

export default SeguimientoMacrosPage;
